import { GridCellProps, GridColumn } from '@progress/kendo-react-grid';
import {
  AsyncGrid,
  DateDisplayCell,
  defaultGridProps,
  GridProvider,
  MainArea,
  PageCard,
  PageCardSection,
  TextIconButton,
} from '@techsharegov/react-ui';
import { AgendaEndpoints } from 'Models/Routes';
import { Routes } from 'Navigation';
import SummarizeSharp from '@mui/icons-material/SummarizeSharp';
import { useCommitteeState } from './CommitteeProvider';

export const CommitteeOpenPositions: React.FC = () => {
  const { committeeId }= useCommitteeState();

  return (
    <PageCard>
      <PageCardSection title="Open Positions">
        <MainArea>
          <GridProvider entityName="Committee Position">
            <AsyncGrid
              isMainGrid
              readEndpoint={AgendaEndpoints.committees.controllerActionString("readOpenPositions") + "/" + committeeId}
              sortable={false}
              {...defaultGridProps}
            >
              <GridColumn field="name" title="Position" sortable={false} />
              <GridColumn field="dateOpened" title="Date Opened" cell={DateDisplayCell} sortable={false} />
              <GridColumn field="id" title=" " cell={ActionsCell} width="auto" sortable={false} />
            </AsyncGrid>
          </GridProvider>
        </MainArea>
      </PageCardSection>
    </PageCard>
  );
};

const ActionsCell: React.FC<GridCellProps> = (props: GridCellProps) => {
  const dataItem = props.dataItem;
  
  const openApplication = async () => {
    window.location.href = Routes.CommitteeApplication + "/" + dataItem?.id;
  };
  
  return (
    <td>
      <TextIconButton
        icon={SummarizeSharp}
        onClick={openApplication}
        className="single-line-btn"
      >
        Apply
      </TextIconButton>
    </td>
  );
};
